export const EVENTS = {
  APP_DATA: {
    REFRESH: 'appdata.refresh',
    REFRESHING: 'appdata.refreshing',
    REFRESH_ERROR: 'appdata.error',
    REFRESHED: 'appdata.refreshed'
  }
};
export const ENDPOINTS = {
  APP_DATA: {
    GET: 'https://api.kingrecharges.com/store/app/data?service=1xpay&userId=1xpay&group=lacasae'
  }
};
